import { defineSchoolFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const founderPreviousSchoolDescriptor = defineSchoolFilter({
  definition: {
    id: FilterId.FOUNDER_PREVIOUS_SCHOOL,
    name: 'Founder Previous School',
    type: FilterType.SCHOOL,
    schoolResultItems: {},
    isVisible: true,
  },
});
